export const defaultLanguages = {
    "zDefault Language": {
        "permission": "Admin",
        "translations": {},
        "type": "TextObject",
        "value": {
            "code": {
                "translations": {
                    "en": "en",
                },
                "value": "en"
            },
            "default": {
                "translations": {
                    "en": "true",
                },
                "value": "true"
            },
            "dir": {
                "translations": {
                    "en": "ltr",
                },
                "value": "ltr"
            },
            "label": {
                "translations": {
                    "en": "English",
                },
                "value": "English"
            },
            "labelFlag": {
                "translations": {
                    "en": "🇺🇸/🇬🇧",
                },
                "value": "🇺🇸/🇬🇧"
            }
        }
    }
};
